module["exports"] = [
  "Phd."
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sk/name/suffix.js
 ** module id = 1046
 ** module chunks = 0
 **/